import React from 'react';
import styled, { keyframes } from 'styled-components';
import { CSSTransition } from 'react-transition-group';

import splashLogo from '~images/logo-splash.svg';
import splashImg from '~images/img-splash.jpg';
import splashImgMobile from '~images/img-splash-mobile.jpg';

import animationStyles from './styles.scss';

const transitionNames = {
  enter: animationStyles.splashAnimEnter,
  enterActive: animationStyles.splashAnimEnterActive,
  exit: animationStyles.splashAnimLeave,
  exitActive: animationStyles.splashAnimLeaveActive,
};

const SplashScreen = ({ show }) => (
  <CSSTransition
    classNames={transitionNames}
    timeout={{ enter: 500, exit: 2000 }}
    in={show}
    unmountOnExit
  >
    <SplashScreenWrapper>
      <SplashImage bg={splashImg} bgMobile={splashImgMobile} />
      <SplashLogo src={splashLogo} alt="splashLogo" />
    </SplashScreenWrapper>
  </CSSTransition>
);

const SplashScreenWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: white;
  z-index: 15;
  overflow-y: hidden !important;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: all 1s ease-in-out;
`;

const SplashImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background-image: url(${props => props.bg});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  opacity: 1;
  transition: opacity 1s ease-out @media (max-width: 1000px) {
    background-image: url(${props => props.bgMobile}) !important;
  }
`;

const slideAndFadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const SplashLogo = styled.img`
  width: 200px;
  height: 200px;
  z-index: 1;
  opacity: 1;
  margin-top: 0;
  transition: all 1s ease-in-out;
  animation-name: ${slideAndFadeIn};
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
  animation-duration: 1.5s;
`;

export default SplashScreen;
